var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image, Text, View } from "react-native";
import { getMangoVopStatusInfo } from "../../../utils/bankAccount.utils";
import images from "../../assets";
import styled from "../../theme/styled-components.native";
var Wrap = styled(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n  flex-direction: row;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 6px;\n  flex-direction: row;\n"])));
var StatusIcon = styled(Image)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 14px;\n  height: 14px;\n  margin-right: 4px;\n  tint-color: ", ";\n"], ["\n  width: 14px;\n  height: 14px;\n  margin-right: 4px;\n  tint-color: ", ";\n"])), function (props) { return props.statusColor; });
var StatusText = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n"])), function (props) { return props.statusColor; });
var VopStatusBadge = function (_a) {
    var status = _a.status;
    var statusInfo = getMangoVopStatusInfo(status);
    if (!statusInfo) {
        return null;
    }
    return (_jsxs(Wrap, { children: [_jsx(StatusIcon, { source: images.ICO_CHECK_BADGE, statusColor: statusInfo.color }), _jsx(StatusText, { statusColor: statusInfo.color, children: statusInfo.title })] }));
};
// eslint-disable-next-line import/no-default-export
export default VopStatusBadge;
var templateObject_1, templateObject_2, templateObject_3;
